import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import type { NoteListResponse } from '@contracts/note/NoteListResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import type { Note } from '@src/notes/domain/Note';
import { NoteParentType } from '@src/notes/domain/Note';

export const NotesClient = {
  findAllForOrder: async (orderId: string): Promise<Note[]> => {
    const { data: response } = await AuthenticatedClient.get<NoteListResponse>(
      `/notes?order=${orderId}`,
    );

    return parseNoteListResponse(response);
  },
  findAllForPermit: async (permitId: string): Promise<Note[]> => {
    const { data: response } = await AuthenticatedClient.get<NoteListResponse>(
      `/notes?permit=${permitId}`,
    );

    return parseNoteListResponse(response);
  },
  addNote: async (request: AddNoteRequest): Promise<void> => {
    await AuthenticatedClient.post('/notes', request);
  },
};

const parseNoteListResponse = (response: NoteListResponse): Note[] => {
  return response.notes.map((note) => ({
    ...note,
    parent: {
      id: note.parent.id,
      name: note.parent.name,
      type: NoteParentType[note.parent.type],
    },
  }));
};
